<div class="card-wrapper">
	<div
		class="card-container"
		(click)="goToDetails(auction.idAuction)"
		[attr.data-type]="getAuctionCardStatus(auction)"
	>
		@if (showAuctionType) {
			<div class="card-header-row">
				<span
					class="auction-type-banner"
					data-type="standard"
				>
					{{ "auctions.traditional" | translate }}
				</span>
				<!-- <span
					class="auction-type-banner"
					data-type="blind"
				>
					{{ "auctions.blind" | translate }}
				</span>
				<span
					class="auction-type-banner"
					data-type="buy-now"
				>
					{{ "auctions.buyNow" | translate }}
				</span> -->
			</div>
		}

		<div class="card-header-row">
			<div class="header-left">
				<!-- <img
						[src]="'assets/icons/flags/' + auction.idMarket.toLowerCase() + '.svg'"
						class="flag-icon"
					/> -->
				<span class="before-ico ico-flag-{{ auction.idMarket.toLowerCase() }} country-label">{{ "menu.country" + auction.idMarket | translate | uppercase }}</span>
			</div>
			<img
				loading="lazy"
				[src]="utils.getImageUrl(auction?.smallLogo)"
				class="auction-logo"
				alt="Logo"
			/>
		</div>

		<div class="card-layout">
			<div class="left-side">
				<div class="title-wrapper">
					<span class="title">{{ auction.auctionName }}</span>
					<div
						class="title-tooltip"
						(click)="$event.stopPropagation()"
					>
						{{ auction.auctionName }}
					</div>
				</div>
                <div class="subtitle-wrapper">
                    <p #subtitleEl class="subtitle">
                        {{ auction.description }}
                    </p>

                    @if (isSubtitleTruncated) {
                        <a
                                class="ck-link ps-0"
                                (click)="$event.stopPropagation(); readMore(auction?.idTemplate)"
                        >
                            {{ "privatePartner.readMore" | translate }}
                        </a>
                    }
                </div>

				<div class="card-count">{{ auction.lotCount }} {{ "auctions.vehicles" | translate }}</div>

				@switch (auction.status) {
					@case ("RUN") {
						@if (utils.isExtraTime(auction)) {
							<div
								class="ck-badge"
								data-color="red"
							>
								{{ "auctions.extraTime" | translate }}
							</div>
							<span class="auction-time-left-label"></span>
							<span
								class="auction-end-label"
								data-type="extra-time"
							>
								{{ "auctions.end" | translate }}
								{{ auction.endDate | date: "dd/MM/yyyy" }}
								{{ "auctions.at" | translate }}
								{{ auction.endDate | ckDate: false : false : false : true }}
							</span>
						} @else {
							<span
								class="ck-badge"
								data-color="lightblue"
							>
								{{ "auctions.runningStatus" | translate }}
							</span>

							@let daysLeft = getDaysLeft(auction.endDate);
							<span class="auction-time-left-label">
								@if (daysLeft > 1) {
									{{ "auctions.daysLeft" | translate: { days: daysLeft } }}
								} @else {
									{{ getHoursLeft(auction.endDate) }}
									{{ "clock.hours" | translate }}
									{{ getMinutesLeft(auction.endDate) }}
									{{ "clock.mins" | translate }}
									{{ "admin.push.remaining" | translate }}
								}
							</span>

							<span
								class="auction-end-label before-ico ico-calendar-end"
								data-type="run"
							>
								{{ "auctions.end" | translate }}
								{{ auction.endDate | date: "dd/MM/yyyy" }}
								{{ "auctions.at" | translate }}
								{{ auction.endDate | ckDate: false : false : false : true }}
							</span>
						}
					}
					@case ("SCH") {
						<!-- SCHEDULED -->
						<div
							class="ck-badge"
							data-color="grey"
						>
							{{ "auctions.startOn" | translate }}
							{{ auction.startDate | date: "dd/MM/yyyy" }}
							{{ "auctions.at" | translate }}
							{{ auction.startDate | ckDate: false : false : false : true }}
						</div>

						<span
							class="auction-end-label before-ico ico-calendar-end"
							data-type="not-started"
						>
							{{ "auctions.end" | translate }}
							{{ auction.endDate | date: "dd/MM/yyyy" }}
							{{ "auctions.at" | translate }}
							{{ auction.endDate | ckDate: false : false : false : true }}
						</span>
					}
				}
			</div>
			<div
				(click)="$event.stopPropagation()"
				class="right-side"
			>
				<vehicle-slider [vehicles]="randomVehicles?.[auction.idAuction]"></vehicle-slider>
			</div>
		</div>
	</div>
</div>
